import React, {Component} from 'react';
import InputField from './components/inputField.js'
import InputLanguage from './components/inputLanguage.js'
import FlightResult from './components/flightResult.js'
import './App.css';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            language: 'en;en-US',
            inputFlight: <span>loading...</span>,
            inputLanguage: '',
            from: '',
            to: '',
            foundFlights: '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.handleInputs();
    }

    handleInputs() {
        this.setState({
            inputFlight: <span>loading...</span>
        });
        let url = 'https://api.skypicker.com/places?v=2&locale=' + this.state.language.split(';')[0];
        fetch(url)
            .then(results => {
                return results.json()
            })
            .then(data => {
                let items = [];
                items.push(data.map((o) => {
                    return {id: o.id, label: o.value}
                }));
                return items[0];
            })
            .then(items => {
                let inputs = (
                    <div id='inputFields'><span>From: </span><InputField
                        handleChange={(place) => this.handleFromChange(place)} items={items}/><span>To: </span><InputField
                        handleChange={(place) => this.handleToChange(place)} items={items}/></div>);
                this.setState({
                    inputFlight: inputs
                });
            });
        this.handleLangInputs();
    }

    handleLangInputs() {
        let langs = ['en;en-US', 'de;de-DE', 'cz;cs-CZ', 'sk;sk-SK'];
        this.setState({
            inputLanguage: (
            <div>
                {langs.map(o => <InputLanguage lang={o} key={o} checked={this.state.language}
                                               handleChange={(event) => this.handleLangChange(event)}/>
                )}
            </div>)
        });
    }

    handleLangChange(e) {
        this.setState({language: e.target.value}, this.handleInputs);
    }

    handleFromChange(place) {
        this.setState({from: place});
    }

    handleToChange(place) {
        this.setState({to: place});
    }

    handleSubmit() {
        if (this.state.from === '' || this.state.to === '') {
            this.setState({foundFlights: <p>You need to specify start and end locations.</p>});
        } else {
            this.setState({foundFlights: <p>Loading...</p>});
            //console.log(new Date(document.getElementById('datetimeFly').value).toLocaleString('DD/MM/YYYY'));
            let date = new Date(document.getElementById('datetimeFly').value);
            let dateFormated = date.getDate() + '%2F' + (date.getMonth() + 1) + '%2F' + date.getFullYear();
            let url = 'https://api.skypicker.com/flights?v=2' +
                '&locale=' + this.state.language.split(';')[0] +
                '&flyFrom=' + this.state.from +
                '&to=' + this.state.to +
                '&dateFrom=' + dateFormated +
                '&dateTo=' + dateFormated;
            fetch(url)
                .then(results => {
                    return results.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.data.length === 0) {
                        this.setState({foundFlights: <p>Did not found single flight. :(</p>});
                    } else {
                        this.setState({
                            foundFlights:
                                data.data.map((o, i) => {
                                    return (
                                        <div key={'result-' + i}>
                                            <span className='flightResultIndex'>{i + 1}.</span>
                                            <FlightResult data={o} local={this.state.language.split(';')[1]}/>
                                        </div>
                                    )
                                })
                        });
                    }
                });
        }
    }

    render() {
        return (
            <div>
                <section>
                    {this.state.inputLanguage}
                    {this.state.inputFlight}
                    <input id='datetimeFly' type="datetime-local"
                           defaultValue={new Date().toISOString().split('T')[0] + 'T00:00'}/>
                    <button onClick={this.handleSubmit}>GO GO GO!</button>
                </section>
                <section>
                    {this.state.foundFlights}
                </section>
            </div>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js